module.exports = __webpack_public_path__ + "static/media/empty_screen.d576fe32.pdn";